
<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Expense Reimbursement Report</h5>
  </div>
<div id="mainContent" class="container">
    <div class="modal-body mt-2">
      <div class="row">
        <div class="col-sm-6">
            <div class="row">
              <label class="col-sm-4 col-form-label"
                >Financial Year<span class="text-danger">*</span></label
              >
              <div class="col-sm-6">
                <select
                  class="form-control form-control-xs mt-1"
                  [(ngModel)]="selectedFinancialYear"
                  (change)="onSelectFinancialYear()"
                >
                  <option value="">Select Year</option>
                  <option *ngFor="let finance of financialList" [ngValue]="finance">
                    {{ finance.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        <div class="col-sm-6">
          <div class="row">
            <label class="col-sm-4">Branch<span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <select
                class="form-control form-control-xs"
                id="branch"
                name="branch"
                [(ngModel)]="branch"
                (change)="onSelectBranch()"
              >
                <option value="">Select Branch</option>
                <option *ngFor="let branch of branchList" [value]="branch.id">
                  {{ branch.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
            <div class="row">
              <label class="col-sm-4 col-form-label"
                >Client Status<span class="text-danger">*</span></label
              >
              <div class="col-sm-6">
                <select
                  class="form-control form-control-xs mt-1"
                  [(ngModel)]="selectedClientStatus"
                  (change)="onStatusSelect()"
                >
                <option value="">Select Status</option>
                  <option value="1">Active</option>
                  <option value="2">Closed</option>
                </select>
              </div>
            </div>
          </div>
        <div class="col-sm-6">
          <div class="row">
            <label class="col-sm-4">Client<span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <select
                class="form-control form-control-xs"
                id="client"
                name="client"
                [(ngModel)]="client"
                (change)="onSelectClient()"
              >
                <option value="">Select Client</option>
                <option *ngFor="let client of clientList" [value]="client.id">
                  {{ client.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
  </div>
  <div class="row">
        <div class="col-sm-6">
          <div class="row">
            <label class="col-sm-4 col-form-label"
              >Bill Date<span class="text-danger">*</span></label
            >
            <div class="col-sm-6">
              <select
                class="form-control form-control-xs mt-1"
                [(ngModel)]="selectBillingDate"
                (change)="onBillingDateSelect()"
              >
                <option value="">Select Billing Date</option>
                <option
                  *ngFor="let billingdate of billingDateList"
                  [ngValue]="billingdate"
                >
                  {{ billingdate.generatedDate }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="row">
            <label class="col-sm-4 col-form-label">Assignments<span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <mat-form-field appearance="legacy" style="width: 100%">
                <mat-select
                  multiple
                  [(ngModel)]="assignment"
                  #designateAssignment="ngModel"
                >
                  <mat-option
                    (click)="
                      selectAllAssignment(designateAssignment, assignmentList)
                    "
                    [value]="0"
                    >Select All
                  </mat-option>
                  <mat-option
                    #item
                    *ngFor="let assignment of assignmentList"
                    [value]="assignment"
                  >
                    {{ assignment.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-2">
          <button
            class="btn btn-sm btn-block btn-outline-theme"
            (click)="viewReport()"
          >
            View Details
          </button>
        </div>
        <div class="col-sm-2" *ngIf="showExportToExcelButton">
            <button
              (click)="exportToExcelForReimbursementReport()"
              class="btn btn-sm btn-block btn-outline-theme"
            >
              <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
            </button>
          </div>
          <div class="col-sm-2" *ngIf="showExportToExcelButton">
            <button
              (click)="convertReimbursementReportIntoPDF()"
              class="btn btn-sm btn-block btn-outline-theme"
            >
              <i class="fa fa-file-pdf-o mr-2"></i>Export as PDF
            </button>
          </div>
      </div>
    </div>
  </div>

  <div class="container pt-3 pb-3" id="mainContent" *ngIf="reportList!=undefined">
    <div id="contentToConvert" style="padding-left: 30px; padding-right: 20px; padding-top:10px;">
      <div class="row justify-content-center text-center border border-dark border-bottom-0">
          <span class="bg-theme-title"
            >P G BHAGWAT LLP, Chartered Accountants
          </span>
        </div>
        <div class="row justify-content-center text-center border border-dark border-top-0">
          <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
        </div>
        <div class="row justify-content-center text-center border border-dark border-top-0 border-bottom-0">
          <span class="bg-theme-title mt-4 mb-4">CLIENT REIMBURSEMENT SHEET </span>
        </div>
        <div class="row">
        <div class="col-sm-6 border border-dark border-bottom-0">
          <span class="bg-theme-title">Client Name
          </span>
        </div>
        <div class="col-sm-6 border border-dark border-left-0 border-bottom-0">
         <span>{{reportList.clientName}}</span> 
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6 border border-dark border-bottom-0">
        <span class="bg-theme-title">Assignment
        </span>
      </div>
      <div class="col-sm-6 border border-dark border-left-0 border-bottom-0">
        <span>{{reportList.assignments}}</span> 
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6 border border-dark border-bottom-0">
      <span class="bg-theme-title">Period Of Reimbursement
      </span>
    </div>
    <div class="col-sm-6 border border-dark border-left-0 border-top-0">
      <div class="row">
        <div class="col-sm-6 border border-dark border-left-0 border-bottom-0">
          <span class="bg-theme-title">Last Invoice
          </span> 
        </div>
        <div class="col-sm-6 border border-dark border-left-0 border-bottom-0 border-right-0">
          <span class="bg-theme-title">Current invoice
          </span>
        </div>
      </div>
  </div>
</div>
<div class="row">
  <div class="col-sm-6 border border-dark border-bottom-0">
    <span class="bg-theme-title">
    </span> 
   </div>
  <div class="col-sm-6">
    <div class="row">
      <div class="col-sm-6 border border-dark border-left-0 border-bottom-0 border-top-0" > 
        <span>{{reportList.lastInvoice | date:'dd-MMMM-yyyy'}}
        </span>
      </div>
      <div class="col-sm-6 border border-dark border-left-0 border-bottom-0 border-top-0">
        <span>{{reportList.currentInvoice | date:'dd-MMMM-yyyy'}}
        </span>
      </div>
    </div>
</div>
</div>

<div class="row">
  <div class="col-sm-6 border border-dark border-bottom-0">
    <span class="bg-theme-title">Invoice Number
    </span>
  </div>
  <div class="col-sm-6 border border-dark border-left-0 border-bottom-0">
    
</div>
</div>

<div class="row">
  <div class="col-sm-6 border border-dark border-bottom-0">
    <span class="bg-theme-title">
    </span>
  </div>
  <div class="col-sm-6 border border-dark border-left-0 border-bottom-0">
    <span class="bg-theme-title">Amount (RS)
    </span>
</div>
</div>
<div class="row">
  <div class="col-sm-6 border border-dark border-bottom-0">
    <span>Conveyance
    </span>
  </div>
  <div class="col-sm-6 border border-dark border-left-0 border-bottom-0">
    <span >{{reportList.conveyance}}
    </span>
</div>
</div>
<div class="row">
  <div class="col-sm-6 border border-dark border-bottom-0">
    <span>Train
    </span>
  </div>
  <div class="col-sm-6 border border-dark border-left-0 border-bottom-0">
    <span >{{reportList.train}}
    </span>
</div>
</div>
<div class="row">
  <div class="col-sm-6 border border-dark border-bottom-0">
    <span>Air
    </span>
  </div>
  <div class="col-sm-6 border border-dark border-left-0 border-bottom-0">
    <span >{{reportList.air}}
    </span>
</div>
</div>
<div class="row">
  <div class="col-sm-6 border border-dark border-bottom-0">
    <span>Taxi
    </span>
  </div>
  <div class="col-sm-6 border border-dark border-left-0 border-bottom-0">
    <span >{{reportList.taxi}}
    </span>
</div>
</div>
<div class="row">
  <div class="col-sm-6 border border-dark border-bottom-0">
    <span>Car
    </span>
  </div>
  <div class="col-sm-6 border border-dark border-left-0 border-bottom-0">
    <span >{{reportList.car}}
    </span>
</div>
</div>
<div class="row">
  <div class="col-sm-6 border border-dark border-bottom-0">
    <span>Toll
    </span>
  </div>
  <div class="col-sm-6 border border-dark border-left-0 border-bottom-0">
    <span >{{reportList.toll}}
    </span>
</div>
</div>
<div class="row">
  <div class="col-sm-6 border border-dark border-bottom-0">
    <span>Hotel Stay
    </span>
  </div>
  <div class="col-sm-6 border border-dark border-left-0 border-bottom-0">
    <span>{{reportList.hotelStay}}
    </span>
</div>
</div>
<div class="row">
  <div class="col-sm-6 border border-dark border-bottom-0">
    <span>Food Expense
    </span>
  </div>
  <div class="col-sm-6 border border-dark border-left-0 border-bottom-0">
    <span >{{reportList.foodExpenses}}
    </span>
</div>
</div>

<!-- <div class="row">
  <div class="col-sm-6 border border-dark border-bottom-0">
    <span>Mobile
    </span>
  </div>
  <div class="col-sm-6 border border-dark border-left-0 border-bottom-0">
    <span>{{reportList.mobile}}
    </span>
</div>
</div>
<div class="row">
  <div class="col-sm-6 border border-dark border-bottom-0">
    <span>Internet
    </span>
  </div>
  <div class="col-sm-6 border border-dark border-left-0 border-bottom-0">
    <span>{{reportList.internet}}
    </span>
</div>
</div>
<div class="row">
  <div class="col-sm-6 border border-dark border-bottom-0">
    <span>ICAI Membership Fee
    </span>
  </div>
  <div class="col-sm-6 border border-dark border-left-0 border-bottom-0">
    <span>{{reportList.icaiMembershipFee}}
    </span>
</div>
</div>
<div class="row">
  <div class="col-sm-6 border border-dark border-bottom-0">
    <span>Microsoft 365 Subscription
    </span>
  </div>
  <div class="col-sm-6 border border-dark border-left-0 border-bottom-0">
    <span>{{reportList.microsoft365Subscription}}
    </span>
</div>
</div>

<div class="row">
  <div class="col-sm-6 border border-dark border-bottom-0">
    <span>Seminar Fee
    </span>
  </div>
  <div class="col-sm-6 border border-dark border-left-0 border-bottom-0">
    <span>{{reportList.seminarFee}}
    </span>
</div>
</div> -->

<div class="row">
  <div class="col-sm-6 border border-dark border-bottom-0">
    <span>Other
    </span>
  </div>
  <div class="col-sm-6 border border-dark border-left-0 border-bottom-0">
    <span>{{reportList.other}}
    </span>
</div>
</div>

<div class="row">
  <div class="col-sm-6 border border-dark">
    <span>Total
    </span>
  </div>
  <div class="col-sm-6 border border-dark border-left-0">
    <span>{{reportList.total}}
    </span>
</div>
</div>

   </div>
  </div>
  </div>
  